import { Injectable } from '@angular/core';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';
import { InspectionReportByNode } from '@psnb/psnb-api';
import { DefaultService } from '@psnb/psnb-api';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelPowersupplyBulkService {
  searchHieArray: any;

  constructor(private powerSupplyService: DefaultService) { }

  public getBulkPowerSupplyReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getBulkPowerSupplyReports(this.searchHieArray);
  }

  public exportPowerSupplyBulkReportAsExcelFile(json: InspectionReportByNode[], excelFileName: string, fileType: string) {
    let min = 0;
    let max = 40000;
    let numberOfSheets = 0;
    if (json.length >= 40000) {
      if (json.length % 40000 === 0) numberOfSheets = json.length / 40000 + 0.5;
      else numberOfSheets = json.length / 40000 + 1;
    } else {
      numberOfSheets = 1.5;
      max = json.length;
    }
    const workbook = new Excel.Workbook;
    for (let i = 1; i <= numberOfSheets; i++) {
      workbook.addWorksheet('PowerSupplyBulkReport' + i);
      let sheet = workbook.getWorksheet(i);
      sheet.columns = this.getHeaders(fileType);
      sheet.addRows(json.slice(min, max));
      if (fileType === 'POWERSUPPLYBULK') {
        sheet = this.addStyles(sheet, true);
      }
      if (max + 40000 <= json.length) {
        min = max;
        max = max + 40000;
      } else {
        min = max;
        max = max + (json.length - max);
      }
    }

    workbook.addWorksheet('Instructions');
    let insSheet = workbook.getWorksheet(Math.ceil(numberOfSheets));
    insSheet.columns = this.insHeaders();
    insSheet = this.addInsData(insSheet);

    workbook.addWorksheet('Power Supply type');
    let psTypesheet = workbook.getWorksheet(Math.ceil(numberOfSheets+1));
    psTypesheet.columns = this.getPSTypeHeaders();
    psTypesheet.addRows(this.getPSTypedata());
    psTypesheet = this.addStyles(psTypesheet, false);

    // workbook.addWorksheet('Controller Cards');
    // let cctSheet = workbook.getWorksheet(Math.ceil(numberOfSheets+2));
    // cctSheet.columns = this.getCCTHeaders();
    // cctSheet.addRows(cct);
    // cctSheet = this.addStyles(cctSheet, false);

    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
    })
    return false;
  }

  getCCTHeaders() {
    return [
      { header: 'Controller Cards', key: 'name', width: 15, style: { font: { name: 'Calibri', family: 2, size: 8 } } }
    ]
  }

  getPSTypeHeaders() {
    return [
      { header: 'Power Supply Type', key: 'type', width: 15, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
      { header: 'Power Supply', key: 'powerSupply', width: 15, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
    ]
  }

  insHeaders() {
    return [
      { width: 170, style: { alignment: { wrapText: true } } }
    ]
  }

  addInsData(sheet: any) {
    sheet.getCell('A1').value = {
      richText: [
        {
          text: "****All Nodes must exist in the PSNB before Bulk Uploading Power Supply Data",
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' }, bold: 'true', width: 165 }
        }
      ]
    };
    sheet.getCell('A2').value = {
      richText: [
        {
          text: "Override (Column A): If you select N for 'No'",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: ", fields with existing data will not be overwritten (Updated)",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " will not be",
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' }, bold: 'true' }
        },
        {
          text: " overwritten (Updated)",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        }
      ]
    };
    sheet.getCell('A3').value = {
      richText: [
        {
          text: "                                     If you select",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " Y for 'Yes'",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: ", fields with existing data",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " will be",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: " overwritten (Updated)",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        }
      ]
    };
    sheet.getCell('A4').value = {
      richText: [
        {
          text: "                                     All fields that are blank in the PSNB will be populated with the data you enter in this template.",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        }
      ]
    };
    sheet.getCell('A5').value = {
      richText: [
        {
          text: 'Power Supply Name must be entred',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: ' when uploading new Power Supplies that ',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: 'do not',
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' }, bold: 'true', underline: true }
        },
        {
          text: ' currently exist in the PSNB',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        }
      ]
    };
    sheet.getCell('A6').value = {
      richText: [
        {
          text: ' \r\nPower Supply Name',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: " or",
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' }, bold: 'true' }
        },
        {
          text: " MAC ",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: "must currently exist",
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' }, bold: 'true', underline: true }
        },
        {
          text: " in the PSNB when",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " appending",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: " to existing Power Supply Data. Otherwise, a new PS Record will be created with a different PS Name \r\nIf changing MAC Address, the Previous MAC Address must be entered into the Previous MAC Address",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " (Column 'H').",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        }
      ]
    };
    sheet.getCell('A7').value = {
      richText: [
        {
          text: "To Add Additional Nodes, list the Nodes in the correct fields, the under",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " 'Feeds Multiple Nodes'",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: " you must type",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " Yes - 2 Nodes",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: " as an example",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        }
      ]
    };
    sheet.getCell('A8').value = {
      richText: [
        {
          text: "You can",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: " delete",
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' }, bold: 'true' }
        },
        {
          text: " addional nodes using this PSBulkUpload Template. \r\n",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: "In order to do so, you must list the Additional Nodes in their respctive fields, then select 'No' for Feeds Multiple Nodes \r\n",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: "This will delete the FN Nodes in Continuity and will remove them from the PSNB \r\n",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        }
      ]
    };
    sheet.getCell('A9').value = {
      richText: [
        {
          text: ' \r\nMake sure there are no leading / trailing spaces in the data \r\n',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        }
      ]
    };
    sheet.getCell('A10').value = {
      richText: [
        {
          text: 'The',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: ' Battery Install Date Fields',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: ' must be entered in this format:',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: ' 12/1/2007',
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        }
      ]
    };
    sheet.getCell('A11').value = {
      richText: [
        {
          text: " \r\nRemove any single quotation marks",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " (')",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' }, bold: 'true' }
        },
        {
          text: " to avoid receiving the following SQL Error when attempting to upload:",
          font: { name: 'Calibri', size: 12, color: { argb: 'FF000000' } }
        },
        {
          text: " Incorrect syntax near '21998'",
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' } }
        }
      ]
    };
    sheet.getCell('A12').value = {
      richText: [
        {
          text: ' \r\nDelete row 2 as this is Example data before uploading',
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' }, bold: 'true' }
        }
      ]
    };
    sheet.getCell('A13').value = {
      richText: [
        {
          text: "Use Migration Field as Y or 'Yes' if Migrating from Legacy PSNB to New PSNB",
          font: { name: 'Calibri', size: 12, color: { argb: 'FFFF0000' }, bold: 'true' }
        }
      ]
    };
    return sheet;
  }

  addStyles(sheet: any, override: boolean) {
    sheet.eachRow(function (row, rowNumber) {
      if (rowNumber != 1 && override) {
        row.getCell(1).value = 'Y';
        //row.getCell(63).value = 'N';
      }
      row.eachCell({ includeEmpty: true }, function (cell) {
        if (rowNumber === 1) {
          sheet.getCell(cell.address.toString()).fill = {
            type: 'gradient', gradient: 'angle', degree: 0, stops: [
              { position: 0, color: { argb: 'd9f1fa' } },
              { position: 0.5, color: { argb: 'd9f1fa' } },
              { position: 1, color: { argb: 'd9f1fa' } }
            ]
          };
          sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
          sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
          sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
        }
      });
    });
    return sheet;
  }

  getHeaders(fileType: string) {
    if (fileType === 'POWERSUPPLYBULK') {
      let wchRegionName = 11;
      let wchId = 9;
      let wchName = 9;
      let wchPowerSupplyName = 20;
      let wchIp = 12;
      let wchMacAddress = 13;
      let wchMacAddressPrevious = 20;
      let wchPsAlertProfile = 30;
      let wchControlledCardType = 18;
      let wchHouseNumber = 12;
      let wchPowerSupplyAddress = 19;
      let wchCrossStreet = 12;
      let wchCity = 10;
      let wchState = 6;
      let wchZip = 8;
      let wchGpsLatitude = 12;
      let wchGpsLongitude = 13;
      let wchPoleNumber = 11;
      let wchPowerCompanyVendor = 21;
      let wchpowerCompanyContactNumber = 21;
      let wchpowerCompanyWebsite = 25;
      let wchCompanyAccountNumber = 25;
      let wchPowersNode = 11;
      let wchElectricMeterNumber = 20;
      let wchMapNumber = 10;
      let wchNode2 = 6;
      let wchNode3 = 6;
      let wchNode4 = 6;
      let wchNode5 = 6;
      let wchNode6 = 6;
      let wchNode7 = 6;
      let wchNode8 = 6;
      let wchNode9 = 6;
      let wchNode10 = 7;
      let wchNode11 = 7;
      let wchNode12 = 7;
      let wchNode13 = 7;
      let wchNode14 = 7;
      let wchNode15 = 7;
      let wchNode16 = 7;
      let wchNode17 = 7;
      let wchNode18 = 7;
      let wchNode19 = 7;
      let wchNode20 = 7;
      let wchNode21 = 7;
      let wchNode22 = 7;
      let wchNode23 = 7;
      let wchNode24 = 7;
      let wchNode25 = 7;
      let wchNode26 = 7;
      let wchNode27 = 7;
      let wchNode28 = 7;
      let wchNode29 = 7;
      let wchNode30 = 7;
      let wchNode31 = 7;
      let wchNode32 = 7;
      let wchNumberOfBatteries = 20;
      let wchcalculatedRuntime = 25;
      let wchPowerSupplyType = 16;
      let wchFeedsMultipleNodes = 18;
      let wchPowerSupplyNumber = 17;
      let wchPowerSupplyType9360 = 20;
      let wchTransponderVendor = 20;
      let wchTransponderModel = 17;
      let wchPowerSupplyModel = 17;
      let wchOutputVoltage = 14;
      let wchACInputVoltage = 14;
      let wchInputCurrent = 13;
      let wchBatteriesReplaced = 17;
      let wchBatteryBalancerString = 23;
      let wchAerialUnderground = 20;
      let wchEgisName = 13;
      let wchFollowUpNeeded = 23;
      let wchnwtTeam = 15;
      let wchnitroCompletionDate = 15;
      let wchnitroReasonNotCompleted = 30;
      let wchVisitStatus=25;
      let wchFollowUpReason=33;
      let wchBusinessPartnerRestriction=20;
      let wchPriority = 25;

      return [
        { header: 'Override', width: wchRegionName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Region', key: 'regionName', width: wchRegionName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node', key: 'node', width: wchName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Power Supply ID', key: 'powerSupplyId', width: wchId, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Power Supply Name', key: 'powerSupplyName', width: wchPowerSupplyName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'IP Address', key: 'ipAddress', width: wchIp, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'MAC Address', key: 'macAddress', width: wchMacAddress, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Previous MAC Address', key: 'previousMacAddress', width: wchMacAddressPrevious, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Alert Profile', key: 'alertProfile', width: wchPsAlertProfile, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        // { header: 'Controller Card Type', key: 'controllerCardType', width: wchControlledCardType, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'House Number', key: 'houseNumber', width: wchHouseNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Address Line 1', key: 'addressLine1', width: wchPowerSupplyAddress, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Cross Street', key: 'crossStreet', width: wchCrossStreet, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'City', key: 'city', width: wchCity, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'State', key: 'state', width: wchState, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'ZIP Code', key: 'zipCode', width: wchZip, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Latitude', key: 'latitude', width: wchGpsLatitude, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Longitude', key: 'longitude', width: wchGpsLongitude, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Pole Number', key: 'poleNumber', width: wchPoleNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        // { header: 'Power Company', key: 'powerCompany', width: wchPowerCompanyVendor, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        // { header: 'Power Company Account Number', key: 'team', width: wchCompanyAccountNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        // { header: 'Power Company Contact Number', key: 'powerCompanyContactNumber', width: wchpowerCompanyContactNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        // { header: 'Power Company Website', key: 'powerCompanyWebsite', width: wchpowerCompanyWebsite, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Powers Node? Yes / No.', key: 'powersNode', width: wchPowersNode, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
       // { header: 'Meter Number', key: 'meterNumber', width: wchElectricMeterNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'MAP #', key: 'mapNumber', width: wchMapNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 2', key: 'node2', width: wchNode2, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 3', key: 'node3', width: wchNode3, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 4', key: 'node4', width: wchNode4, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 5', key: 'node5', width: wchNode5, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 6', key: 'node6', width: wchNode6, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 7', key: 'node7', width: wchNode7, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 8', key: 'node8', width: wchNode8, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 9', key: 'node9', width: wchNode9, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 10', key: 'node10', width: wchNode10, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 11', key: 'node11', width: wchNode11, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 12', key: 'node12', width: wchNode12, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 13', key: 'node13', width: wchNode13, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 14', key: 'node14', width: wchNode14, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 15', key: 'node15', width: wchNode15, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 16', key: 'node16', width: wchNode16, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 17', key: 'node17', width: wchNode17, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 18', key: 'node18', width: wchNode18, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 19', key: 'node19', width: wchNode19, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 20', key: 'node20', width: wchNode20, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 21', key: 'node21', width: wchNode21, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 22', key: 'node22', width: wchNode22, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 23', key: 'node23', width: wchNode23, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 24', key: 'node24', width: wchNode24, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 25', key: 'node25', width: wchNode25, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 26', key: 'node26', width: wchNode26, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 27', key: 'node27', width: wchNode27, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 28', key: 'node28', width: wchNode28, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 29', key: 'node29', width: wchNode29, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 30', key: 'node30', width: wchNode30, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 31', key: 'node31', width: wchNode31, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node 32', key: 'node32', width: wchNode32, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Batteries', key: 'batteries', width: wchNumberOfBatteries, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Priority', key: 'priority', width: wchPriority, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        //{ header: 'Calculated Runtime(in Minutes)', key: 'calculatedRuntime', width: wchcalculatedRuntime, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'StandBy/Non-StandBy', key: 'standByStatus', width: wchPowerSupplyType, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Feeds Multiple Nodes', key: 'feedsMultipleNodes', width: wchFeedsMultipleNodes, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Power Supply Number', key: 'powerSupplyNumber', width: wchPowerSupplyNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Next Gen Node', key: 'nextGenNode', width: wchPowerSupplyNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Power Supply Type (9360 Model)', key: 'powerSupplyType9360', width: wchPowerSupplyType9360, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Transponder Vendor', key: 'transponderVendor', width: wchTransponderVendor, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Transponder Model', key: 'transponderModel', width: wchTransponderModel, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Power Supply Model', key: 'powerSupplyModel', width: wchPowerSupplyModel, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Output Voltage', key: 'outputVoltage', width: wchOutputVoltage, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'AC Input Voltage', key: 'acInputVoltage', width: wchACInputVoltage, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Current Amp Rating', key: 'currentAmpRating', width: wchInputCurrent, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Batteries Replaced', key: 'batteriesReplaced', width: wchBatteriesReplaced, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'BatteryBalancerString', key: 'batteryBalancerString', width: wchBatteryBalancerString, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Aerial/UG', key: 'aerialOrUg', width: wchAerialUnderground, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        //{ header: 'EGISNumber', key: 'egisName', width: wchEgisName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'FollowUpActionNeeded', key: 'followUpActionNeeded', width: wchFollowUpNeeded, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        // { header: 'Migration(Y/N)', key: 'migration', width: wchRegionName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },

        { header: 'NWTTeam', key: 'nwtTeam', width: wchnwtTeam, style: { font: { name: 'Calibri', family: 2, size: 8 } } },

        { header: 'NitroCompletionDate', key: 'nitroCompletionDate', width: wchnitroCompletionDate, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        //{ header: 'PowerAccountType', key: 'powerAccountType', width: wchnitroReasonNotCompleted, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'BusinessPartnerRestriction', key: 'businessPartnerRestriction', width: wchBusinessPartnerRestriction, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'VisitStatus', key: 'visitStatus', width: wchVisitStatus, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'FollowUpReason', key: 'followUpReason', width: wchFollowUpReason, style: { font: { name: 'Calibri', family: 2, size: 8 } } }
      ]
    }
  }

  getPSTypedata() {
    const data: any[] = [];
    data.push({ type: 1, powerSupply: "Unknown" });
    data.push({ type: 2, powerSupply: "Alpha XM2 - 120V" });
    data.push({ type: 3, powerSupply: "Alpha XM2 - 240V" });
    data.push({ type: 4, powerSupply: "Alpha XM - 120V" });
    data.push({ type: 5, powerSupply: "Alpha XM - 240V" });
    data.push({ type: 6, powerSupply: "Alpha AM/AP - 120V" });
    data.push({ type: 7, powerSupply: "Alpha AM/AP - 220V" });
    data.push({ type: 8, powerSupply: "Lectro (36V or 48V)ZTT - 120V" });
    data.push({ type: 9, powerSupply: "Lectro (36V or 48V)ZTT - 240V" });
    data.push({ type: 10, powerSupply: "Lectro ZTT+ - 120V" });
    data.push({ type: 11, powerSupply: "Lectro ZTT+ - 240V" });
    data.push({ type: 12, powerSupply: "Generic - 120V" });
    data.push({ type: 13, powerSupply: "Generic - 240V" });
    data.push({ type: 14, powerSupply: "Lectro CPR - 120V" });
    data.push({ type: 15, powerSupply: "Lectro CPR - 240V" });
    data.push({ type: 16, powerSupply: "Lectro 24VZTT - 120V" });
    data.push({ type: 17, powerSupply: "Lectro Sentry II" });
    data.push({ type: 18, powerSupply: "APC - 120V" });
    data.push({ type: 19, powerSupply: "APC - 240V" });
    return data;
  }
}
